import axios from "axios";

const Api = axios.create({
    baseURL: "https://api7.sistelk.id/external",
    // baseURL: "http://localhost:3002/external",
    headers: {
        "Content-Type": "application/json",
        "x-api-key": "a1214a664a6f27a33a6e392cc8ecc1c07deb075cc6bc9683b22143c45333eb70",
    },
});

export default Api;